import React from 'react';
import { AiOutlineWarning } from "react-icons/ai";
import { IconContext } from 'react-icons';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';

import './NotAxisAlignedWarningOverlay.css';
import * as sagas from '../../store/sagas';
import { StoreState } from '../../store/store';


export type NotAxisAlignedWarningOverlayProps = {
    isAxisAligned: boolean,
}

type DispatchProps = {
    dismissOrientationWarning: () => void,
}

type AllProps = NotAxisAlignedWarningOverlayProps & StoreState & DispatchProps;

class NotAxisAlignedWarningOverlay extends React.PureComponent<AllProps> {
    
    handleDismissWarning =  () => {
        this.props.dismissOrientationWarning();
    }

    render() {
        if (this.props.isAxisAligned || !this.props.isOrientationWarningShown) {
            return null;
        }

        return (
            <Alert variant="warning" className="not-axis-aligned-warning-alert" dismissible onClose={this.handleDismissWarning}>
                <div className="not-axis-aligned-warning-overlay">
                    <div className="warning-logo"><IconContext.Provider value={{ size: '64px' }}><AiOutlineWarning /></IconContext.Provider></div>
                    <div className="warning-body"><b>WARNING</b> -- this scan is not axis-aligned and contouring it is <b>not supported</b>. Please do not annotate this scan for model development, and inform the project manager.</div>
                </div>
            </Alert>
        );
    }
}

export default connect(
    state => Object.assign({}, state),
    sagas.mapDispatchToProps
)(NotAxisAlignedWarningOverlay);
